import React from 'react';

const Gdpr = () => {

    return (
        <div className="container">
            <h1>Zásady používání cookies a ochrany osobních údajů</h1>
            <h2>1. Úvod</h2>
            <p>Tato stránka popisuje, jak společnost <strong>Erste marketing s.r.o.</strong>, se sídlem Sokolská 1095, 280 02 Kolín, IČO: <strong>19634960</strong>, jako provozovatel webu www.rychlydum.cz, zpracovává osobní údaje návštěvníků a jak používá soubory cookies.</p>
            <p>Ochrana vašeho soukromí je pro nás důležitá. S veškerými osobními údaji nakládáme v souladu s platnými právními předpisy, zejména Nařízením EU 2016/679 (GDPR).</p>
            <h2>2. Jaké údaje zpracováváme</h2>
            <p>Na našem webu zpracováváme tyto typy údajů:</p>
            <ul>
                <li><strong>Kontaktní údaje</strong>, které nám poskytnete ve formulářích (jméno, příjmení, e-mail, telefon, obsah zprávy).</li>
                <li><strong>Údaje o chování na webu</strong> (návštěvnost, pohyb na stránkách, interakce), které získáváme pomocí měřicích nástrojů.</li>
                <li><strong>Technické údaje</strong> (IP adresa, typ prohlížeče, zařízení, operační systém).</li>
            </ul>
            <h2>3. Účely zpracování</h2>
            <p>Vaše údaje využíváme k těmto účelům:</p>
            <ol>
                <li><strong>Vyřízení poptávek a komunikace</strong> prostřednictvím kontaktních formulářů.</li>
                <li><strong>Analýza návštěvnosti a zlepšování služeb</strong> – pomocí nástroje Google Analytics.</li>
                <li><strong>Personalizace a měření účinnosti reklamy</strong> – prostřednictvím Google Ads a Meta Pixelu (Facebook).</li>
                <li><strong>Zajištění bezpečnosti webu</strong> a prevence zneužití.</li>
            </ol>
            <h2>4. Soubory cookies</h2>
            <p>Cookies jsou malé textové soubory, které se ukládají do vašeho zařízení. Používáme:</p>
            <ul>
                <li><strong>Technické cookies</strong> – nezbytné pro správné fungování webu.</li>
                <li><strong>Analytické cookies</strong> – pro měření návštěvnosti (Google Analytics).</li>
                <li><strong>Marketingové cookies</strong> – pro personalizaci a vyhodnocování reklam (Google Ads, Meta Pixel).</li>
            </ul>
            <p>Před ukládáním analytických a marketingových cookies vás žádáme o souhlas prostřednictvím cookie lišty. Souhlas můžete kdykoli odvolat v nastavení prohlížeče nebo pomocí odkazu v patičce webu.</p>
            <h2>5. Předávání údajů třetím stranám</h2>
            <p>Osobní údaje předáváme pouze důvěryhodným partnerům, kteří nám pomáhají provozovat web a měřit jeho výkon (např. Google Ireland Ltd., Meta Platforms Ireland Ltd.). Všichni tito partneři zpracovávají údaje v souladu s GDPR a mají vhodná ochranná opatření.</p>
            <h2>6. Doba uchování údajů</h2>
            <ul>
                <li>Údaje z formulářů uchováváme po dobu nezbytnou k vyřízení vašeho požadavku, maximálně 3 roky.</li>
                <li>Cookies se uchovávají po dobu uvedenou v jejich nastavení (nejdéle 13 měsíců, není-li vyžadována delší doba).</li>
            </ul>
            <h2>7. Vaše práva</h2>
            <p>Máte právo:</p>
            <ul>
                <li>na přístup k osobním údajům,</li>
                <li>na opravu či výmaz údajů,</li>
                <li>na omezení zpracování,</li>
                <li>na přenositelnost údajů,</li>
                <li>vznést námitku proti zpracování,</li>
                <li>podat stížnost u Úřadu pro ochranu osobních údajů (www.uoou.cz).</li>
            </ul>
            <p>Svůj souhlas se zpracováním cookies nebo osobních údajů můžete kdykoli odvolat zasláním žádosti na e-mail <a href="mailto:info@rychlydum.cz"><strong>info@rychlydum.cz</strong></a>.</p>
            <h2>8. Kontakt na správce</h2>
            <p>Správcem vašich údajů je:</p>
            <p>
                <strong>Erste marketing s.r.o.</strong><br />
                Sokolská 1095, 280 02 Kolín<br />
                IČO: 19634960<br />
                E-mail: <a href="mailto:info@rychlydum.cz"><strong>info@rychlydum.cz</strong></a>
            </p>
        </div>
    )
}

export default Gdpr;